import { useEffect, useRef, useState } from 'react';

import promoVideoMP4Url from '@assets/video/promo.mp4';
import promoVideoWebmUrl from '@assets/video/promo.webm';
import { useMediaQuery } from '@utils/hooks/useMediaQuery';
import { getMediaqueryDual } from '@utils/utils';

import { Wrapper, Lead, Title, Video, StyledButtonVolume, StyledButtonPlay } from './Intro.styled';

export const Intro: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isPlayButtonVisible, setIsPlayButtonVisible] = useState(true);
  const [isFirstHiding, setIsFirstHiding] = useState(true);

  const isDesktop = useMediaQuery(getMediaqueryDual('desktop'));

  const handleVolumeButtonClick = () => {
    setIsMuted(!isMuted);
  };

  const handlePlayButtonClick = () => {
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    if (!isDesktop) {
      setIsMuted(false);
      setIsPlaying(false);
      video.currentTime = 3;
    } else {
      setIsMuted(true);
      setIsPlaying(true);
      video.currentTime = 0;
    }
  }, [isDesktop]);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    isPlaying ? video.play() : video.pause();

    if (!isDesktop) {
      const handleVideoTouch = () => {
        setIsPlayButtonVisible(!isPlayButtonVisible);
      };

      if (isPlaying) {
        if (isFirstHiding) {
          setIsPlayButtonVisible(false);
          setIsFirstHiding(false);
        } else {
          video.addEventListener('touchstart', handleVideoTouch);
        }
      } else {
        setIsPlayButtonVisible(true);
        setIsFirstHiding(true);

        video.removeEventListener('touchstart', handleVideoTouch);
      }

      return () => {
        video.removeEventListener('touchstart', handleVideoTouch);
      };
    }
  }, [isDesktop, isPlaying, isFirstHiding, isPlayButtonVisible]);

  return (
    <Wrapper>
      <Title>Women in esports and competitive gaming</Title>
      <Lead>They&apos;re just good enougth</Lead>
      <Video ref={videoRef} playsInline autoPlay muted={isMuted} loop>
        <source src={promoVideoWebmUrl} type="video/webm" />
        <source src={promoVideoMP4Url} type="video/mp4" />
      </Video>
      {isDesktop ? (
        <StyledButtonVolume isMuted={isMuted} onClick={handleVolumeButtonClick} />
      ) : (
        <StyledButtonPlay isPlaying={isPlaying} isVisible={isPlayButtonVisible} onClick={handlePlayButtonClick} />
      )}
    </Wrapper>
  );
};
